<template>
    <div :class="'mb25 ' + div_class">
        <input
                :data-user_id="cb_user_id"
                :class="cb_class"
                v-model="cb_user_subscribed"
                type="checkbox"
                value="1"
                :name="cb_name"
                :id="cb_name"
                @change="changeState($event)"
        />
        <label class="order__club-label" :for="cb_name">
            <span class="order__club-title">Я вступаю в клуб Хобби Центр</span>
            <span class="order__club-text">
                  Вы будете получать индивидуальные предложения, бесплатные приглашения на мероприятия семинары и тренинги, а также сможете участвовать в закрытых распродажах
            </span>
        </label>
    </div>
</template>

<script>
    export default {
        name: "check-box",
        props: ['user_id','css_class','user_subscribed','name'],
        data : function () {
            return {
                'div_class' : this.css_class,
                'cb_class' : this.css_class + '-checbox',
                'cb_user_id' : this.user_id,
                'cb_user_subscribed' : this.user_subscribed,
                'cb_name' : this.name,
            };
        },
        methods: {
            changeState: function(el) {
                let params = new URLSearchParams();
                params.append('action', 'subscribe');
                params.append('mlist_id', 108);
                params.append('user_id', this.user_id);
                params.append('subscribe', (this.cb_user_subscribed) ? 'yes' : 'no');
                axios.put('/rest/profile',params)
                    .then((response) => {})
            }
        }
    }
</script>
